import { SvgIcon } from 'ui/icons/SvgIcon';

export const EventConditionArrowSvg = ({ isNestedJoin, ...rest }: any) => (
  <SvgIcon height={16} width={16} viewBox="0 0 16 16" fill="none" {...rest}>
    <path
      d="M11.5 11.5L14.5 8.5L11.5 5.5"
      stroke="#787174"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 2.5V4.5C1.5 5.56087 1.92143 6.57828 2.67157 7.32843C3.42172 8.07857 4.43913 8.5 5.5 8.5H14.5"
      stroke="#787174"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
